/**
 * Subtle, first-time-only entrance animation for homepage sections. IntersectionObserver only — no
 * animation library, nothing scroll-linked. Elements opt in with [data-reveal]; an optional inline
 * --reveal-delay custom property staggers related elements (e.g. a row of product cards). Each element
 * is revealed once and then left alone, and the whole thing is skipped in favour of the plain resting
 * state when the visitor has prefers-reduced-motion set.
 */
(function () {
  if (document.documentElement.hasAttribute('data-reveal-bound')) return;
  document.documentElement.setAttribute('data-reveal-bound', '');

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function ready() {
    var els = document.querySelectorAll('[data-reveal]');
    if (!els.length) return;

    if (reduceMotion || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-revealed'); });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });

    els.forEach(function (el) { observer.observe(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ready);
  } else {
    ready();
  }
})();
